export enum AgentChatControlMessageEnum {
  Interrupt = '[Przerwano odpowiedź]',
}
